import React from "react";

import { alpha, Box, Stack, useTheme } from "@mui/material";
import Paper from "@mui/material/Paper";
import MUITable from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Check, Credit } from "components/icons";
import { fontWeight } from "config/Theme/options";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";
import { useTranslation } from "react-i18next";
import { IBitcoinerChallengeLevel } from "types/types";
import { renderNumber } from "utils/formatter";
interface IProps {
  levels: IBitcoinerChallengeLevel[];
  levelNumber: number;
}

const Table: React.FC<IProps> = ({ levels, levelNumber }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { colors } = useMUIThemeModeContext();

  const filteredLevels = React.useMemo(() => levels.slice(1, -1), [levels]);

  return (
    <TableContainer component={Paper} sx={{ marginTop: 2, borderRadius: 2 }} elevation={0}>
      <MUITable>
        <TableHead>
          <TableRow
            sx={{
              "& tr, & th": {
                border: 0,
                px: 1.25,
                py: 0.5,
                fontFamily: "Nunito",
                color: "primary.main",
                fontSize: { xs: "0.875rem", md: "1rem" },
                fontWeight: fontWeight.extraBold,
              },
            }}>
            <TableCell align="center">{t("bitcoinerChallenge.table.level")}</TableCell>
            <TableCell align="center">{t("bitcoinerChallenge.table.xpRequired")}</TableCell>
            <TableCell align="center">{t("bitcoinerChallenge.table.creditsReward")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredLevels.map((level) => {
            const isAchievedLevel = level.level <= levelNumber;
            const isNextLevel = level.level === levelNumber + 1;

            const bgColor = isAchievedLevel
              ? alpha(colors.success, 0.1)
              : isNextLevel
              ? alpha(theme.palette.primary.main, 0.1)
              : undefined;
            const color = isAchievedLevel ? colors.success : undefined;

            return (
              <TableRow
                key={level.level}
                sx={{
                  "& td, & th": {
                    border: 0,
                    px: 1.25,
                    py: 0.5,
                    fontFamily: "Nunito",
                    fontSize: { xs: "0.75rem", md: "0.875rem" },
                    fontWeight: fontWeight.semiBold,
                    color: color,
                  },
                  backgroundColor: bgColor,
                }}>
                <TableCell align="center">{level.level}</TableCell>
                <TableCell align="center">{`${renderNumber(level.xpRequired)} XP`}</TableCell>
                <TableCell align="center">
                  <Stack direction="row" justifyContent="center" spacing={0.5}>
                    <Box textAlign="center" display={"flex"}>
                      {isAchievedLevel && <Check sx={{ fontSize: "0.875rem", marginRight: 0.5, marginTop: 0.2 }} />}
                      {renderNumber(level.creditsReward)}
                    </Box>
                    <Credit sx={{ fontSize: "1rem" }} />
                  </Stack>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </MUITable>
    </TableContainer>
  );
};

export default Table;
